function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoNFTCard = require('../../../../../lib/saito/ui/saito-nft/saito-nft-card');
var NftPickerTemplate = require('./nft-picker.template');
var _require = require('../../categories'),
  isVaultRentalNftType = _require.isVaultRentalNftType,
  isSellableNftType = _require.isSellableNftType,
  normalizeListingMode = _require.normalizeListingMode;
var NftPickerOverlay = /*#__PURE__*/function () {
  function NftPickerOverlay(app, mod) {
    _classCallCheck(this, NftPickerOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.card_list = [];
    this.defaults = {};
    this.listing_mode = 'sell';
    this.onSelect = null;
    this.create_nft_overlay = null;
  }
  return _createClass(NftPickerOverlay, [{
    key: "render",
    value: function render() {
      var _this = this;
      var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.defaults = defaults || {};
      this.listing_mode = normalizeListingMode(this.defaults.listing_mode);
      this.overlay.show(NftPickerTemplate({
        listing_mode: this.listing_mode
      }), function () {
        var _this$defaults;
        if (typeof ((_this$defaults = _this.defaults) === null || _this$defaults === void 0 ? void 0 : _this$defaults.callback) === 'function') {
          _this.defaults.callback({
            status: 'cancelled'
          });
        }
      });
      this.attachModeEvents();
      this.renderNftGrid();
    }
  }, {
    key: "returnRecordType",
    value: function returnRecordType() {
      var rec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      try {
        var _rec$slip;
        return this.app.wallet.extractNFTType((rec === null || rec === void 0 || (_rec$slip = rec.slip3) === null || _rec$slip === void 0 ? void 0 : _rec$slip.utxo_key) || '') || '';
      } catch (_) {
        return '';
      }
    }
  }, {
    key: "matchesListingMode",
    value: function matchesListingMode() {
      var nft_type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.listing_mode === 'rent') {
        return isVaultRentalNftType(nft_type);
      }
      return isSellableNftType(nft_type);
    }

    /**
     * One card per NFT id. Fractional slips of the same NFT share an id and
     * collide on #nft-card-${uuid}; keep the first record and let SaitoNFT
     * aggregate units via returnAllSlips / getTotalAmount.
     */
  }, {
    key: "dedupeNftRecords",
    value: function dedupeNftRecords() {
      var nft_list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var seen = new Set();
      var unique = [];
      var _iterator = _createForOfIteratorHelper(nft_list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rec = _step.value;
          var id = rec === null || rec === void 0 ? void 0 : rec.id;
          if (id == null || id === '') {
            unique.push(rec);
            continue;
          }
          var key = String(id);
          if (seen.has(key)) {
            continue;
          }
          seen.add(key);
          unique.push(rec);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return unique;
    }
  }, {
    key: "hasNftPayload",
    value: function hasNftPayload(nft) {
      return !!(nft !== null && nft !== void 0 && nft.tx || nft !== null && nft !== void 0 && nft.image || nft !== null && nft !== void 0 && nft.text || nft !== null && nft !== void 0 && nft.js || nft !== null && nft !== void 0 && nft.css || nft !== null && nft !== void 0 && nft.json);
    }

    /**
     * Prefer the picker card already hydrated from archive (same id), not a
     * sibling slip instance that still has an empty image/tx.
     */
  }, {
    key: "resolveSelectedNft",
    value: function resolveSelectedNft(nft) {
      var _this2 = this;
      var incoming = (nft === null || nft === void 0 ? void 0 : nft.nft) || nft;
      if (!incoming) {
        return incoming;
      }
      var id = incoming.id;
      if (id == null || id === '') {
        return incoming;
      }
      var cards = this.card_list.filter(function (card) {
        var _card$nft;
        return String(card === null || card === void 0 || (_card$nft = card.nft) === null || _card$nft === void 0 ? void 0 : _card$nft.id) === String(id);
      });
      var hydrated = cards.find(function (card) {
        return _this2.hasNftPayload(card.nft);
      }) || cards[0];
      return (hydrated === null || hydrated === void 0 ? void 0 : hydrated.nft) || incoming;
    }
  }, {
    key: "attachModeEvents",
    value: function attachModeEvents() {
      var _this3 = this;
      var select = document.querySelector('.nft-picker [data-listing-mode-select]');
      if (!select) {
        return;
      }
      select.onchange = function (e) {
        var next = normalizeListingMode(e.target.value);
        if (next === _this3.listing_mode) {
          return;
        }
        _this3.listing_mode = next;
        _this3.defaults.listing_mode = next;
        _this3.render(_objectSpread(_objectSpread({}, _this3.defaults), {}, {
          listing_mode: next,
          callback: _this3.defaults.callback
        }));
      };
    }
  }, {
    key: "renderNftGrid",
    value: function () {
      var _renderNftGrid = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this4 = this;
        var container, statusEl, instructionsEl, nft_list, _iterator2, _step2, _loop, i, _iterator3, _step3, card, _t, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              container = document.querySelector('.nft-picker [data-nft-grid]');
              statusEl = document.querySelector('.nft-picker [data-nft-status]');
              instructionsEl = document.querySelector('.nft-picker [data-nft-instructions]');
              if (container) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return this.app.wallet.updateNFTList();
            case 2:
              nft_list = this.dedupeNftRecords((this.app.options.wallet.nfts || []).filter(function (rec) {
                return _this4.matchesListingMode(_this4.returnRecordType(rec));
              }));
              this.card_list.forEach(function (card) {
                card.delete_me = true;
              });
              _iterator2 = _createForOfIteratorHelper(nft_list);
              _context2.p = 3;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var rec, existing;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      rec = _step2.value;
                      existing = _this4.card_list.find(function (card) {
                        var _card$nft2;
                        return (rec === null || rec === void 0 ? void 0 : rec.id) != null && rec.id !== '' && String(card === null || card === void 0 || (_card$nft2 = card.nft) === null || _card$nft2 === void 0 ? void 0 : _card$nft2.id) === String(rec.id);
                      });
                      if (!existing) {
                        _context.n = 1;
                        break;
                      }
                      existing.callback = function (nft) {
                        return _this4.handleSelect(nft);
                      };
                      delete existing.delete_me;
                      return _context.a(2, 1);
                    case 1:
                      _this4.card_list.push(new SaitoNFTCard(_this4.app, _this4.mod, '.nft-picker [data-nft-grid]', null, rec, function (nft) {
                        return _this4.handleSelect(nft);
                      }));
                    case 2:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _iterator2.s();
            case 4:
              if ((_step2 = _iterator2.n()).done) {
                _context2.n = 7;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 5);
            case 5:
              if (!_context2.v) {
                _context2.n = 6;
                break;
              }
              return _context2.a(3, 6);
            case 6:
              _context2.n = 4;
              break;
            case 7:
              _context2.n = 9;
              break;
            case 8:
              _context2.p = 8;
              _t = _context2.v;
              _iterator2.e(_t);
            case 9:
              _context2.p = 9;
              _iterator2.f();
              return _context2.f(9);
            case 10:
              for (i = this.card_list.length - 1; i >= 0; i--) {
                if (this.card_list[i].delete_me) {
                  this.card_list.splice(i, 1);
                }
              }
              container.innerHTML = '';
              if (nft_list.length) {
                _context2.n = 11;
                break;
              }
              if (statusEl) {
                statusEl.innerHTML = NftPickerTemplate.emptyInstructions(this.listing_mode);
              }
              if (instructionsEl) {
                instructionsEl.hidden = false;
                instructionsEl.innerHTML = NftPickerTemplate.createPrompt(this.listing_mode);
                if (this.listing_mode === 'sell') {
                  this.attachEmptyEvents();
                }
              }
              return _context2.a(2);
            case 11:
              if (statusEl) {
                statusEl.innerHTML = '';
              }
              if (instructionsEl) {
                instructionsEl.hidden = true;
                instructionsEl.innerHTML = '';
              }
              _iterator3 = _createForOfIteratorHelper(this.card_list);
              _context2.p = 12;
              _iterator3.s();
            case 13:
              if ((_step3 = _iterator3.n()).done) {
                _context2.n = 15;
                break;
              }
              card = _step3.value;
              _context2.n = 14;
              return card.render();
            case 14:
              _context2.n = 13;
              break;
            case 15:
              _context2.n = 17;
              break;
            case 16:
              _context2.p = 16;
              _t2 = _context2.v;
              _iterator3.e(_t2);
            case 17:
              _context2.p = 17;
              _iterator3.f();
              return _context2.f(17);
            case 18:
              return _context2.a(2);
          }
        }, _callee, this, [[12, 16, 17, 18], [3, 8, 9, 10]]);
      }));
      function renderNftGrid() {
        return _renderNftGrid.apply(this, arguments);
      }
      return renderNftGrid;
    }()
  }, {
    key: "attachEmptyEvents",
    value: function attachEmptyEvents() {
      var _this5 = this;
      var createLink = document.getElementById('nft-picker-create-link');
      if (!createLink) {
        return;
      }
      var open = function open(e) {
        e.preventDefault();
        _this5.openCreateNft();
      };
      createLink.onclick = open;
      createLink.onkeydown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          _this5.openCreateNft();
        }
      };
    }

    /**
     * Close the picker and open Create NFT.
     * Prefers the header-owned instance so we do not register a second listener.
     */
  }, {
    key: "openCreateNft",
    value: function openCreateNft() {
      this.overlay.close();
      var createNft = this.mod.header && this.mod.header.select_nft_overlay && this.mod.header.select_nft_overlay.create_nft_overlay;
      if (!createNft) {
        if (!this.create_nft_overlay) {
          var CreateNFT = require('../../../../../lib/saito/ui/saito-nft/overlays/create-overlay');
          this.create_nft_overlay = new CreateNFT(this.app, this.mod);
        }
        createNft = this.create_nft_overlay;
      }
      createNft.render(this.defaults || {});
    }
  }, {
    key: "handleSelect",
    value: function () {
      var _handleSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(nft) {
        var selected, nft_type;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              selected = this.resolveSelectedNft(nft);
              if (!(selected && !this.hasNftPayload(selected) && typeof selected.fetchTransaction === 'function')) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return new Promise(function (resolve) {
                var settled = false;
                var finish = function finish() {
                  if (!settled) {
                    settled = true;
                    resolve();
                  }
                };
                selected.fetchTransaction(finish);
                setTimeout(finish, 5000);
              });
            case 1:
              nft_type = (typeof (selected === null || selected === void 0 ? void 0 : selected.returnType) === 'function' ? selected.returnType() : '') || (selected === null || selected === void 0 ? void 0 : selected.nft_type) || '';
              if (this.matchesListingMode(nft_type)) {
                _context3.n = 2;
                break;
              }
              siteMessage(this.listing_mode === 'rent' ? 'Choose a Vault rental NFT (vault-nft-rental) to list for rent.' : 'That NFT is not available for sale listings. Switch to RENT or pick another NFT.', 3500);
              return _context3.a(2);
            case 2:
              // Avoid treating a successful pick as a cancel when the picker closes.
              if (this.defaults) {
                this.defaults.callback = null;
                this.defaults.listing_mode = this.listing_mode;
              }
              this.overlay.close();
              if (typeof this.onSelect === 'function') {
                this.onSelect(selected, _objectSpread(_objectSpread({}, this.defaults), {}, {
                  listing_mode: this.listing_mode
                }));
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee2, this);
      }));
      function handleSelect(_x) {
        return _handleSelect.apply(this, arguments);
      }
      return handleSelect;
    }()
  }]);
}();
module.exports = NftPickerOverlay;